export enum ScoreComponentType {
  AI,
  USAGE,
}
